import React from "react";
import styles from "./Spinner.module.scss";
export default function Spinner() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles["lds-ring"]
  }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null));
}
//# sourceMappingURL=Spinner.js.map